import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { claimAiBuild } from '../services/AiChatService';
import { canonicalBuildPath, localGenPath } from '../utils/buildRoutes';
import './AiClaim.css';

const TXT_LOADING = {
    fr: 'Connexion en cours et recuperation du build...',
    en: 'Connecting and recovering build...',
    de: 'Verbindung wird hergestellt und Build wird geladen...',
    es: 'Conectando y recuperando la build...',
    pt: 'Conectando e recuperando a build...',
};

const TXT_ERROR = {
    fr: 'Impossible de recuperer ce build AI.',
    en: 'Could not recover this AI build.',
    de: 'Dieser KI-Build konnte nicht geladen werden.',
    es: 'No se ha podido recuperar esta build de IA.',
    pt: 'Não foi possível recuperar esta build de IA.',
};

const TXT_BACK_HOME = {
    fr: 'Retour accueil',
    en: 'Back home',
    de: 'Zurück zur Startseite',
    es: 'Volver al inicio',
    pt: 'Voltar ao início',
};

const TXT_OPEN_GEN = {
    fr: 'Ouvrir generateur',
    en: 'Open generator',
    de: 'Generator öffnen',
    es: 'Abrir el generador',
    pt: 'Abrir o gerador',
};

function t(dict, lang) {
    return dict[lang] || dict.en || dict.fr || '';
}

const AiClaim = () => {
    const { lang = 'fr' } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const token = useMemo(() => (searchParams.get('token') || '').trim(), [searchParams]);

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            if (!token) {
                if (!cancelled) {
                    setError(t(TXT_ERROR, lang));
                }
                return;
            }
            try {
                const build = await claimAiBuild(token);
                const ownerSlug = build?.owner?.public_slug;
                const buildCode = build?.publicCode;
                if (ownerSlug && buildCode) {
                    navigate(canonicalBuildPath(lang, ownerSlug, buildCode), { replace: true });
                    return;
                }
                navigate(localGenPath(lang), { replace: true });
            } catch (err) {
                if (!cancelled) {
                    const msg = err?.response?.data?.error || t(TXT_ERROR, lang);
                    setError(msg);
                }
            }
        };

        run();
        return () => {
            cancelled = true;
        };
    }, [lang, navigate, token]);

    if (!error) {
        return (
            <main className="ai-claim-page">
                <p>{t(TXT_LOADING, lang)}</p>
            </main>
        );
    }

    return (
        <main className="ai-claim-page">
            <p>{error}</p>
            <div className="ai-claim-actions">
                <Link to={`/${lang}`}>
                    <button type="button" className="primary">
                        {t(TXT_BACK_HOME, lang)}
                    </button>
                </Link>
                <Link to={localGenPath(lang)}>
                    <button type="button" className="secondary">
                        {t(TXT_OPEN_GEN, lang)}
                    </button>
                </Link>
            </div>
        </main>
    );
};

export default AiClaim;
